<template>
  <div>
    <navbar class="navbar" />

    <v-tabs
      v-model="tab"
    >
      <v-tab>หมวดหมู่หลัก</v-tab>
      <v-tab>หมวดหมู่รอง</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
          <v-card-text>
            <main-category />
          </v-card-text>
      </v-tab-item>
      <v-tab-item>
          <v-card-text>
            <sub-category />
          </v-card-text>
      </v-tab-item>
    </v-tabs-items>

  </div>
</template>

<script>
import script from '@/views/pages/products/category/index.script';

export default script;
</script>
